import Vue from 'vue';
class UserDetail {
  constructor(id, firstName, lastName, yearOfAge, gender, nationality, note, isUnknown, monthOfAge,
    ageTotalDays, nationalCode, clothesColorAndType, specialCharacteristic, birthDate, patientResult, hospitalId) {
    this.id = id
    this.isUnknown = isUnknown;
    this.firstName = firstName;
    this.lastName = lastName;
    this.yearOfAge = yearOfAge;
    this.monthOfAge = monthOfAge;
    this.ageTotalDays = ageTotalDays;
    this.nationalCode = nationalCode;
    this.birthDate = birthDate;
    this.gender = gender;
    this.nationality = nationality;
    this.clothesColorAndType = clothesColorAndType;
    this.specialCharacteristic = specialCharacteristic;
    this.note = note;
    this.patientResult = patientResult;
    this.hospitalId = hospitalId;
  }
}

export default {
  data() {
    return {
      misssionReportInformationTableHeaders: [
        {
          text: '',
          value: 'hasDoctor',
          align: 'center',
          sortable: false,
          width: '35px',
          isGroupable: false,
        },
        {
          text: 'تاریخ',
          value: 'date',
          align: 'center',
          width: '100px',
          isGroupable: true,
        },
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          width: '150px',
          isGroupable: true,
        },
        {
          text: 'کد آمبولانس',
          value: 'ambulance',
          align: 'center',
          width: '130px',
          isGroupable: true,
        },
        {
          text: 'کد شبرنگ',
          value: 'vehicleCode',
          align: 'center',
          width: '130px',
          isGroupable: true,
        },
        {
          text: 'شماره پرونده',
          value: 'identifier',
          align: 'center',
          width: '130px',
          isGroupable: true,
        },
        {
          text: 'حدود سن',
          value: 'age',
          align: 'center',
          width: '120px',
          isGroupable: true,
        },
        {
          text: 'جنسیت',
          value: 'gender',
          align: 'center',
          width: '110px',
          isGroupable: true,
        },
        {
          text: 'نتیجه',
          value: 'result',
          align: 'center',
          width: '170px',
          isGroupable: true,
        },
        {
          text: 'شکایت اصلی',
          value: 'chiefComplant',
          align: 'center',
          width: '180px',
          isGroupable: true,
        },
        {
          text: 'تشخیص احتمالی پرستار',
          value: 'diagnosis',
          align: 'center',
          width: '150px',
          isGroupable: true,
        },
        {
          text: 'آدرس',
          value: 'address',
          align: 'center',
          width: '400px',
          isGroupable: true,
        },
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: '200px',
          isGroupable: true,
        },
        {
          text: 'تلفن اصلی',
          value: 'mianPhone',
          align: 'center',
          width: '150px',
          isGroupable: true,
        },
        {
          text: 'تلفن پیگیری',
          value: 'otherPhone',
          align: 'center',
          width: '150px',
          isGroupable: true,
        },
        {
          text: 'برچسب',
          value: 'tagTitle',
          align: 'center',
          width: '150px',
          isGroupable: true,
        },
        {
          text: 'تایید پزشک',
          value: 'doctorAccept',
          align: 'center',
          sortable: false,
          width: '100px',
          isGroupable: true,
        },
        {
          text: 'پذیرش بدون رضایت',
          value: 'admissionWithOutPermission',
          sortable: false,
          align: 'center',
          width: '200px',
          isGroupable: true,
        },
      ],
      activeTab: 0,
      showEditUserDetaiModal: false,
      confirmType: '',
      missionReportDataTableInfo: [],
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      searchMissionIdentifier: '',
      searchFullName: '',
      isSearchedUnknownPerson: false,
      searchMainPhoneNumber: '',
      searchOtherPhoneNumber: '',
      searchPhoneCode: '',
      startTriage: false,
      currentUserReport: false,
      searchTagId: null,
      searchRank: null,
      searchAddress: '',
      searchCityId: null,
      searchFromDate: '',
      searchToDate: '',
      searchPatientResult: '',
      chiefComplaintChangeText: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      showMenu: false,
      x: 0,
      y: 0,
      rightClickItems: [
        { title: 'مشاهده پرونده', icon: 'mdi-text-box mdi-18px' },
        { title: 'مشاهده محدود پرونده', icon: 'mdi-file-document mdi-18px' },
        { title: 'ویرایش اطلاعات مدد جو', icon: 'mdi-human-edit mdi-18px' },
        { title: 'تماس ها', icon: 'mdi-phone mdi-flip-h mdi-18px' },
        { title: 'روند پرونده', icon: 'mdi-clipboard-text-clock mdi-18px' },
        { title: 'کاربران', icon: 'mdi-account mdi-flip-h mdi-18px' },
        { title: 'جزئیات ماموریت', icon: 'mdi-script-text mdi-18px' },
        { title: 'فایل های پیوست شده', icon: 'mdi-attachment mdi-18px' },
        { title: 'تریاژ', icon: 'mdi-face-agent mdi-18px' },
        { title: 'تریاژ استارت', icon: 'mdi-alarm-light mdi-18px' },
      ],
      missionPhoneId: null,
      missionId: null,
      patientId: null,
      phoneId: null,
      multiDiagnosis: false,
      allPatientDiagnosis: [],
      singleDiagnosis: null,
      closeOnContentClick: false,
      // detail***********************
      missionDetailModal: false,
      //users***********************
      missionUsersModal: false,
      users: [],
      //calls***********************
      missionCallsModal: false,
      misssionCallsInformationTableHeaders: [
        { text: 'تاریخ', value: 'date', align: 'center' },
        { text: 'کاربر', value: 'user', align: 'center' },
        { text: 'از شماره', value: 'fromNumber', align: 'center' },
        { text: 'به شماره', value: 'toNumber', align: 'center' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      missionCallsDataTableInfo: [],
      recordFile: '',
      player: false,
      downloadPer: false,
      //attachment
      missionFillesModal: false,
      misssionFillesInformationTableHeaders: [
        { text: 'تاریخ', value: 'date', align: 'center' },
        { text: 'کاربر', value: 'user', align: 'center' },
        { text: 'نوع فایل', value: 'attachmentType', align: 'center' },
        { text: 'توضیحات', value: 'note', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      missionFillesDataTableInfo: [],
      //triage
      missionTriagesModal: false,
      misssionTriagesInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'تاریخ', value: 'date', align: 'center' },
        { text: 'سوال', value: 'question', align: 'center' },
        { text: 'جواب', value: 'answer', align: 'center' },
      ],
      missionTriagesDataTableInfo: [],
      //logs
      missionLogsModal: false,
      missionLogsInfo: [],
      // start-triage
      isStartTriageModalOpen: false,
      startTriageTableHeaders: [
        { text: 'تاریخ', value: 'date', align: 'center' },
        { text: 'کدکارت تریاژ', value: 'identifier', align: 'center' },
        { text: 'رنگ کارت تریاژ', value: 'color', align: 'center' },
      ],
    };
  },
  methods: {
    // openStart-triage
    setStartTriageModalOpen: function (value) {
      this.isStartTriageModalOpen = value;
    },
    closeStartTriageModal: function () {
      this.isStartTriageModalOpen = false;
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
    },
    makeReportDataReady: function (data) {
      this.missionReportDataTableInfo = [];
      for (let i = 0; i < data.length; i++) {
        let hasDoctor = false;
        let date = '-';
        let fullName = '';
        let age = '';
        let gender = '';
        let color = '';
        let doctorAccept = false;
        let admissionWithOutPermission = false;
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('jYYYY/jM/jD HH:mm:ss');
        }
        if (data[i].firstName) {
          fullName += data[i].firstName + ' ';
        }
        if (data[i].lastName) {
          fullName += data[i].lastName;
        }
        if (!fullName) {
          fullName = '-';
        }
        if (data[i].yearOfAge) {
          age = data[i].yearOfAge + '(سال)' + ' ';
        }
        if (data[i].monthOfAge) {
          age += data[i].monthOfAge + '(ماه)';
        }
        if (data[i].doctorConfirm) {
          doctorAccept = true;
        }
        if (data[i].hasDoctor) {
          hasDoctor = true;
        }
        if (data[i].admissionWithoutConsent) {
          admissionWithOutPermission = true;
        }
        if (data[i].rank == 0) {
          color = '#D1D1D1';
        } else if (data[i].rank == 1) {
          color = '#3BCA79';
        } else if (data[i].rank == 2) {
          color = '#F2BD27';
        } else if (data[i].rank == 3) {
          color = '#F56060';
        }
        if (data[i].gender == 1) {
          gender = 'مرد';
        } else if (data[i].gender == 2) {
          gender = 'زن';
        } else if (data[i].gender == 3) {
          gender = 'نامشخص';
        }
        let allDiagnosis = [];
        if (data[i].patientDiagnoses) {
          for (let j = 0; j < data[i].patientDiagnoses.length; j++) {
            const patientDiagnose = data[i].patientDiagnoses[j].typeOfEmergency;
            if (data[i].patientDiagnoses[j].typeOfEmergency.title == 'ترومایی مرتبط با حمل و نقل') {
              allDiagnosis.push({
                title: data[i].patientDiagnoses[j].typeOfEmergency.title,
                id: j + 1,
              });
            } else if (
              data[i].patientDiagnoses[j].typeOfEmergency.title == 'ترومایی غیرمرتبط با حمل و نقل'
            ) {
              allDiagnosis.push({
                title: data[i].patientDiagnoses[j].typeOfEmergency.title,
                id: j + 1,
              });
            } else if (data[i].patientDiagnoses[j].typeOfEmergency.title == 'بیماری') {
              if (data[i].patientDiagnoses[j].diagnosis == 'سکته مغزی') {
                allDiagnosis.push({
                  title: data[i].patientDiagnoses[j].diagnosis,
                  id: j + 1,
                });
              } else if (data[i].patientDiagnoses[j].diagnosis == 'مشکلات قلبی') {
                allDiagnosis.push({
                  title: data[i].patientDiagnoses[j].diagnosis,
                  id: j + 1,
                });
              } else {
                allDiagnosis.push({
                  title: data[i].patientDiagnoses[j].diagnosis,
                  id: j + 1,
                });
              }
            } else if (patientDiagnose?.id === 4) {
              allDiagnosis.push({
                title: patientDiagnose?.title,
                id: patientDiagnose?.id,
              });
            }
          }
        }
        this.missionReportDataTableInfo.push({
          hasDoctor: hasDoctor,
          date: date,
          fullName: fullName,
          ambulance: data[i].phoneCode ? data[i].phoneCode : '-',
          identifier: data[i].missionIdentifier ? data[i].missionIdentifier : '-',
          age: age,
          hospital: data[i].hospitalTitle ? data[i].hospitalTitle : '-',
          result: data[i].result ? data[i].result : '-',
          chiefComplant: data[i].chiefComplaintText ? data[i].chiefComplaintText : '-',
          diagnosis: data[i].diagnosisTitle ? data[i].diagnosisTitle : '-',
          address: data[i].address ? data[i].address : '-',
          mianPhone: data[i].mainPhoneNumber ? data[i].mainPhoneNumber : '-',
          otherPhone: data[i].otherPhoneNumber ? data[i].otherPhoneNumber : '-',
          doctorAccept: doctorAccept,
          admissionWithOutPermission: admissionWithOutPermission,
          gender: gender,
          color: color,
          missionPhoneId: data[i].missionPhoneId ? data[i].missionPhoneId : null,
          tagTitle: data[i]?.tagTitle ?? '-',
          missionId: data[i].missionId ? data[i].missionId : null,
          patientId: data[i].patientId ? data[i].patientId : null,
          allDiagnosis: allDiagnosis,
          vehicleCode: data[i]?.vehicleCode ?? '-',
          myData: data[i]
        });
      }
    },
    //search
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    clearMissionId: function () {
      if (this.$route.query?.missionId) {
        this.$router.replace({
          query: {},
        });
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    backToSurveyReport: function () {
      this.$router.push({ name: 'qcSurveyReport' });
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getMissionReportfunction();
    },
    removeFilters: function () {
      this.searchCityId = null;
      this.searchMissionIdentifier = '';
      this.searchFullName = '';
      this.searchMainPhoneNumber = '';
      this.searchOtherPhoneNumber = '';
      this.searchPhoneCode = '';
      this.startTriage = false;
      this.searchTagId = null;
      this.searchRank = null;
      this.searchAddress = '';
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.isSearchedUnknownPerson = false;
      this.isSearchedUnknownPerson = false;
      this.currentUserReport = false;
      this.searchPatientResult = null;
      this.chiefComplaintChangeText = null;
      this.clearMissionId();
      this.getMissionReportfunction();
    },
    cancelSearch: function () {
      this.searchCityId = null;
      this.searchMissionIdentifier = '';
      this.searchFullName = '';
      this.isSearchedUnknownPerson = false;
      this.searchMainPhoneNumber = '';
      this.searchOtherPhoneNumber = '';
      this.searchPhoneCode = '';
      this.startTriage = false;
      this.searchTagId = null;
      this.searchRank = null;
      this.searchAddress = '';
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
      this.currentUserReport = false;
      this.isSearchedUnknownPerson = false;
      this.searchPatientResult = null;
      this.chiefComplaintChangeText = null;
    },
    closeDetailModal: function () {
      this.missionDetailModal = false;
    },
    //right click
    rightClickHandler(e, data) {
      e.preventDefault();
      this.missionPhoneId = data.item.missionPhoneId;
      this.missionId = data.item.missionId;
      this.patientId = data.item.patientId;
      this.phoneId = data.item.phoneId;
      this.selectedRowId = `${(data?.item?.missionPhoneId ?? 0)}` + `${(data?.item?.patientId ?? 0)}`;

      if (data.item.allDiagnosis.length > 1) {
        this.multiDiagnosis = true;
        this.allPatientDiagnosis = [];
        for (let i = 0; i < data.item.allDiagnosis.length; i++) {
          this.allPatientDiagnosis.push(data.item.allDiagnosis[i].title);
        }
      } else if (data.item.allDiagnosis.length == 1) {
        if (data.item.allDiagnosis[0].title == 'ترومایی مرتبط با حمل و نقل') {
          this.singleDiagnosis = 1;
        } else if (data.item.allDiagnosis[0].title == 'ترومایی غیرمرتبط با حمل و نقل') {
          this.singleDiagnosis = 2;
        } else if (data.item.allDiagnosis[0].title == 'سکته مغزی') {
          this.singleDiagnosis = 3;
        } else if (data.item.allDiagnosis[0].title == 'مشکلات قلبی') {
          this.singleDiagnosis = 4;
        } else {
          this.singleDiagnosis = 5;
        }
        this.multiDiagnosis = false;
      } else {
        this.multiDiagnosis = null;
      }
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    rightClickAction: function (type, sItem) {
      this.showMenu = false;
      if (type == 'مشاهده پرونده') {
        if (this.multiDiagnosis != null) {
          if (sItem == 'ترومایی مرتبط با حمل و نقل') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 1;
            const routeData = this.$router.resolve({
              name: 'missionReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == 'ترومایی غیرمرتبط با حمل و نقل') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 2;
            const routeData = this.$router.resolve({
              name: 'missionReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == 'سکته مغزی') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 3;
            const routeData = this.$router.resolve({
              name: 'missionReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == 'مشکلات قلبی') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 4;
            const routeData = this.$router.resolve({
              name: 'missionReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == null) {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + this.singleDiagnosis;
            const routeData = this.$router.resolve({
              name: 'missionReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 5;
            const routeData = this.$router.resolve({
              name: 'missionReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          }
        } else {
          const id = this.missionPhoneId + '-' + 0 + '-' + 6;
          const routeData = this.$router.resolve({
            name: 'missionReportExport',
            params: { id: id },
          });
          window.open(routeData.href, '_blank');
        }
      } else if (type == 'مشاهده محدود پرونده') {
        if (this.multiDiagnosis != null) {
          if (sItem == 'ترومایی مرتبط با حمل و نقل') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 1;
            const routeData = this.$router.resolve({
              name: 'missionLimitReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == 'ترومایی غیرمرتبط با حمل و نقل') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 2;
            const routeData = this.$router.resolve({
              name: 'missionLimitReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == 'سکته مغزی') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 3;
            const routeData = this.$router.resolve({
              name: 'missionLimitReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == 'مشکلات قلبی') {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 4;
            const routeData = this.$router.resolve({
              name: 'missionLimitReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else if (sItem == null) {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + this.singleDiagnosis;
            const routeData = this.$router.resolve({
              name: 'missionLimitReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          } else {
            let id = this.missionPhoneId + '-' + this.patientId + '-' + 5;
            const routeData = this.$router.resolve({
              name: 'missionLimitReportExport',
              params: { id: id },
            });
            window.open(routeData.href, '_blank');
          }
        } else {
          const id = this.missionPhoneId + '-' + 0 + '-' + 6;
          const routeData = this.$router.resolve({
            name: 'missionLimitReportExport',
            params: { id: id },
          });
          window.open(routeData.href, '_blank');
        }
      } else if (type == 'تماس ها') {
        this.getMissionCallsfunction(this.missionId);
      } else if (type == 'روند پرونده') {
        this.getMissionLogsfunction(this.missionId, this.missionPhoneId);
      } else if (type == 'کاربران') {
        this.missionUsersModal = true;
        this.getMissionPhoneReportUsersFunction(this.missionPhoneId, this.patientId);
      } else if (type == 'جزئیات ماموریت') {
        this.missionDetailModal = true;
      } else if (type == 'ویرایش اطلاعات مدد جو') {
        try {
          this.getListOfAllActiveHospitalsFunction();
        } catch (error) { console.log("A error : ", error); }
        this.getPatientForEditReportFunction(this.patientId);
        this.getModificationsPatientsFunction(this.patientId);
        this.confirmType = "edit"
        this.activeTab = 0;
        this.showEditUserDetaiModal = true;
      } else if (type == 'فایل های پیوست شده') {
        if (this.patientId) {
          this.getPatientAttachmentFunction(this.patientId);
        } else {
          this.snackText = 'ماموریت بدون مددجواست';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
        }
      } else if (type === 'تریاژ') {
        this.getAllTriageAnswersByMissionId(this.missionId);
        this.getAllTriageQuestionsByMissionId(this.missionId);
        this.missionTriagesModal = true;
      } else if (type === 'تریاژ استارت') {
        this.setStartTriageModalOpen(true);
        this.getAllMissionStartTriages(this.missionPhoneId);
      }
    },

    showConfirmDialogFunction: function () {
      if (this.confirmType == 'edit') {

        if (!this.userDetail.isUnknown) {
          if (!this.userDetail.firstName) {
            this.snackText = 'نام نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }
          if (!this.userDetail.lastName) {
            this.snackText = 'نام خانوادگی نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }
          // if (!this.userDetail.nationalCode) {
          //   this.snackText = 'کد ملی نمی تواند خالی باشد';
          //   this.$refs.snackRef.snackModel = true;
          //   this.snackColor = '#FF5252';
          //   this.snakIcon = 'mdi-information';
          //   this.disabelConfirm = false;
          //   return;
          // }
          if (this.isChildren && !this.userDetail.ageTotalDays) {
            this.snackText = ' سن نوزاد (روز) نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }
          if (!this.isChildren && !this.userDetail.yearOfAge) {
            this.snackText = 'سال سن نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }

          if (!this.userDetail.nationality) {
            this.snackText = 'ملیت نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }
          if (!this.userDetail.gender) {
            this.snackText = 'جنسیت نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }
          // if (!this.userDetail.birthDate) {
          //   this.snackText = 'تاریخ نمی تواند خالی باشد';
          //   this.$refs.snackRef.snackModel = true;
          //   this.snackColor = '#FF5252';
          //   this.snakIcon = 'mdi-information';
          //   this.disabelConfirm = false;
          //   return;
          // }
        } else {
          if (!this.userDetail.clothesColorAndType) {
            this.snackText = 'نوع و رنگ لباس نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }
          if (!this.userDetail.specialCharacteristic) {
            this.snackText = 'مشخصه خاص نمی تواند خالی باشد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            this.disabelConfirm = false;
            return;
          }
        }
        if ((this.userDetail.patientResult &&
          (this.userDetail.patientResult?.result?.id == 1 ||
            this.userDetail.patientResult?.result?.id == 11)) &&
          !this.userDetail.hospitalId) {
          this.snackText = 'لطفا بیمارستان را انتخاب کنید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return
        }
        if (!this.userDetail.note.replace(/\s/g, '').length) {
          this.snackText = 'توضیحات نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }

        this.$refs.confirm.title = 'ویرایش اطلاعات مدد جو';
        this.$refs.confirm.text = 'از ویرایش اطلاعات مدد جو اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confirmType == 'edit') {
        this.disabelConfirm = true;
        this.setPatientForEditReportFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confirmType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    cancelAddEditFunction: function () {
      this.userDetail = new UserDetail(null, '', '', null, '', '', '', false, null, null, null, '', '', '', null, null);
      this.showEditUserDetaiModal = false;
    },

    loadMissionReportUsers: function (temp) {
      this.users = [];
      let user1 = '';
      let user2 = '';
      let user3 = '';
      let user4 = '';
      let user5 = '';
      let user6 = '';
      if (temp.creatorUser) {
        let fName = temp.creatorUser.firstName ? temp.creatorUser.firstName : '-';
        let lName = temp.creatorUser.lastName ? temp.creatorUser.lastName : '-';
        user1 = fName + ' ' + lName;
      }
      if (temp.dispatchUser) {
        let fName = temp.dispatchUser.firstName ? temp.dispatchUser.firstName : '-';
        let lName = temp.dispatchUser.lastName ? temp.dispatchUser.lastName : '-';
        user2 = fName + ' ' + lName;
      }
      if (temp.doctor) {
        let fName = temp.doctor.firstName ? temp.doctor.firstName : '-';
        let lName = temp.doctor.lastName ? temp.doctor.lastName : '-';
        user3 = fName + ' ' + lName;
      }
      if (temp.seniorTechnician) {
        let fName = temp.seniorTechnician.firstName ? temp.seniorTechnician.firstName : '-';
        let lName = temp.seniorTechnician.lastName ? temp.seniorTechnician.lastName : '-';
        user4 = fName + ' ' + lName;
      }
      if (temp.firstTechnician) {
        let fName = temp.firstTechnician.firstName ? temp.firstTechnician.firstName : '-';
        let lName = temp.firstTechnician.lastName ? temp.firstTechnician.lastName : '-';
        user5 = fName + ' ' + lName;
      }
      if (temp.secondTechnician) {
        let fName = temp.secondTechnician.firstName ? temp.secondTechnician.firstName : '-';
        let lName = temp.secondTechnician.lastName ? temp.secondTechnician.lastName : '-';
        user6 = fName + ' ' + lName;
      }
      this.users.push(
        {
          title: 'کارشناس پاسخگو',
          content: user1,
          col: 6,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'کارشناس واحد اعزام',
          content: user2,
          col: 6,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'پزشک 50-10',
          content: user3,
          col: 6,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'تکنسین ارشد',
          content: user4,
          col: 6,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'تکنسین اول',
          content: user5,
          col: 6,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'تکنسین دوم',
          content: user6,
          col: 6,
          icon: 'mdi-account mdi-18px',
        },
      );
    },
    closeUsersModal: function () {
      this.users = [];
      this.missionUsersModal = false;
    },
    makeMissionCallsDataReady: function (data) {
      this.missionCallsModal = true;
      this.missionCallsDataTableInfo = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          let date = '-';
          let user = '';
          if (data[i].creationDate) {
            date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
          }
          if (data[i].user) {
            let fName = data[i].user.firstName ? data[i].user.firstName : '-';
            let lName = data[i].user.lastName ? data[i].user.lastName : '-';
            user = fName + ' ' + lName;
          }
          this.missionCallsDataTableInfo.push({
            date: date,
            user: user,
            fromNumber: data[i].callLogCallerId ? data[i].callLogCallerId : '-',
            toNumber: data[i].destination ? data[i].destination : '-',
            duration: data[i].duration ? data[i].duration : '-',
            callLogId: data[i].callLogId ? data[i].callLogId : null,
          });
        }
      }
    },
    copyText: function (txt) {
      navigator.clipboard.writeText(txt).then(
        () => {
          this.snackText = 'متن با موفقیت کپی شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        },
        () => {
          console.error('Failed to copy');
        },
      );
    },
    triggerOnEachItem: function (data, wholeData, evt) {
      const cellText = evt?.target?.textContent;
      if (['-', ''].every((item) => item !== cellText) && typeof cellText === 'string') {
        this.copyText(cellText);
      }
    },

    closeCallsModal: function () {
      try {
        this.$root.$refs.Home.playerHome = false;
      } catch (error) { console.log(error); }

      this.missionCallsDataTableInfo = [];
      this.missionCallsModal = false;
    },
    stopMusic: function () {
      var sound = this.$refs.audioFile;
      sound.pause();
      sound.currentTime = 0;
      this.player = false;
    },
    //attachment
    loadAttachmentData: function (data) {
      this.missionFillesModal = true;
      this.missionFillesDataTableInfo = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          let date = '-';
          let user = '';
          let attachmentType = '';
          if (data[i].creationDate) {
            date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
          }
          if (data[i].attachmentType == 0) {
            attachmentType = 'عکس مددجو';
          } else if (data[i].attachmentType == 1) {
            attachmentType = 'براءت نامه';
          } else if (data[i].attachmentType == 2) {
            attachmentType = 'ECG';
          } else {
            attachmentType = '-';
          }
          if (data[i].user) {
            let fName = data[i].user.firstName ? data[i].user.firstName : '-';
            let lName = data[i].user.lastName ? data[i].user.lastName : '-';
            user = fName + ' ' + lName;
          }
          this.missionFillesDataTableInfo.push({
            date: date,
            user: user,
            note: data[i].note ? data[i].note : '-',
            id: data[i].id ? data[i].id : null,
            attachmentType: attachmentType,
            filePath: data[i].filePath ? data[i].filePath : '-',
          });
        }
      }
    },
    closeAttachmentModal: function () {
      this.missionFillesDataTableInfo = [];
      this.missionFillesModal = false;
    },
    showAttachment: function (path) {
      window.open(path, '_blank');
    },
    downloadAttachment: async function (path) {
      const image = await fetch(path);
      const imageBlog = await image.blob();
      const imageURL = URL.createObjectURL(imageBlog);
      const url = imageURL;
      const link = document.createElement('a');
      link.href = url;
      let name = Vue.moment().format('HH:mm:ss-jYYYY/jM/jD');
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    //triage
    makeMissionTriagesDataReady: function (data) {
      this.missionTriagesModal = true;
      this.missionTriagesDataTableInfo = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          let date = '-';
          if (data[i].creationDate) {
            date = Vue.moment(data[i].creationDate).format('HH:mm:ss');
          }
          this.missionTriagesDataTableInfo.push({
            date: date,
            counter: i + 1,
            question: data[i].question ? data[i].question : '-',
            id: data[i].id ? data[i].id : null,
            answer: data[i].answer ? data[i].answer : '-',
          });
        }
      }
    },
    closeTriageModal: function () {
      this.missionTriagesDataTableInfo = [];
      this.missionTriagesModal = false;
    },
    //logs
    makeMissionLogsDataReady: function (data) {
      this.missionLogsModal = true;
      this.missionLogsInfo = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          let date = '-';
          let user = '-';
          if (data[i].logDate) {
            date = Vue.moment(data[i].logDate).format('HH:mm:ss - jYYYY/jM/jD');
          }
          if (data[i].user) {
            let fName = data[i].user.firstName ? data[i].user.firstName : '-';
            let lName = data[i].user.lastName ? data[i].user.lastName : '-';
            user = fName + ' ' + lName;
          }
          this.missionLogsInfo.push({
            date: date,
            user: user,
            id: data[i].id ? data[i].id : null,
            note: data[i].log ? data[i].log : '-',
          });
        }
      }
    },
    closeLogModal: function () {
      this.missionLogsInfo = [];
      this.missionLogsModal = false;
    },
  },
  computed: {
    transformedTriageAnswers: function () {
      return [...this.allTriageAnswers].map(({ answer, id }) => {
        const answerRank = answer?.rank;
        const answerRankColor =
          answerRank === 0
            ? '#F4F4F4'
            : answerRank === 1
              ? '#A4FFCB'
              : answerRank === 2
                ? '#FFE290'
                : '#FFAFAF';
        answer = { ...answer, answerRankColor };
        return {
          answer,
          id,
        };
      });
    },
    excelTableData: function () {
      return [...this.missionReportDataTableInfo].map(
        ({ doctorAccept, admissionWithOutPermission, ...rest }) => {
          const doctorAcceptTxt = doctorAccept ? 'بله' : 'خیر';
          const admissionWithOutPermissionTxt = admissionWithOutPermission ? 'بله' : 'خیر';
          return {
            ...rest,
            doctorAccept: doctorAcceptTxt,
            admissionWithOutPermission: admissionWithOutPermissionTxt,
          };
        },
      );
    },
    time: function () {
      return this.$root.$refs.Home.time;
    },
  },
  watch: {
    isSearchedUnknownPerson: function (currentVal) {
      if (currentVal) this.searchFullName = '';
    },
    '$route.query': {
      handler: function (currentVal) {
        if (currentVal?.missionId) this.isSearch = true;
      },
      immediate: true,
    },
  },
};
